import type { IconData } from '@stacksjs/iconify-core'

export const cloud: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M382.76 432H136c-30.732 0-61.371-12.725-84.061-34.912c-23.221-22.707-36.009-52.35-36.009-83.469A109.4 109.4 0 0 1 49.136 235.2a122.3 122.3 0 0 1 62.794-32.707V200c0-79.4 64.6-144 144-144s144 64.6 144 144v1.453c55.716 7.939 96 53.729 96 112.166c0 31.27-11.375 60.72-32.031 82.927A109.75 109.75 0 0 1 382.76 432M255.93 88a112.127 112.127 0 0 0-112 112v31.405l-14.864 1.059c-45.5 3.239-81.136 38.887-81.136 81.155C47.93 359.635 89.084 400 136 400h246.76c45.515 0 81.17-37.943 81.17-86.381c0-46.566-33.731-80.791-80.2-81.379l-15.8-.2V200a112.127 112.127 0 0 0-112-112\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cloud
